import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadAdminDependencies } from 'ProtectedRoute/useLoadAdminDependencies';

const AdminUsersDirective = angularDirectiveToReact('adminUsers', {});

export function AdminUsersComponent() {
    useLoadAdminDependencies();
    const [key] = useAngularToReactRoute();
    return <AdminUsersDirective key={key} />;
}
